module.exports = __webpack_public_path__ + "static/media/no-image.67015b05.png";